import empholidaysReducer from "./reducers";
export { default as empholidaysTypes } from "./types";
export { default as empholidaysOperations } from "./operations";
export default empholidaysReducer;
